import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import TextInputMaskFormik from "../../../../components/UI/TextInput/TextInputMaskFormik";
import TextInputMoneyFormik from "../../../../components/UI/TextInput/TextInputMoneyFormik";
import useAcoesDemonstrativo from "../hooks/useAcoesDemonstrativo";

const DemonstrativoQ = ({ formik, sqAcaoFiscal, sqItemOcorrencia, dadosOcorrencia, tipoDetalhamento }) => {
  const { handleMoneyChange, calculaData, calculaIcmsDet } = useAcoesDemonstrativo({
    formik,
    sqAcaoFiscal,
  });
  const [tituloVlDeclarado, setTituloVlDeclarado] = useState("Crédito Indevido");
  const [tituloVlApurado, setTituloVlApurado] = useState("Saldo Credor/Deduções");
  const [disabled, setDisabled] = useState(false);
  const { setFieldValue } = formik;

  useEffect(() => {
    if (dadosOcorrencia) {
      setFieldValue("sqAcaoFiscal", sqAcaoFiscal);
      setFieldValue("sqItemOcorrencia", sqItemOcorrencia);
      setFieldValue("sqItem", dadosOcorrencia.sqItem);
      setFieldValue("txReferencia", dadosOcorrencia.txReferencia);
      setFieldValue("dtVencimento", dadosOcorrencia.dtVencimento);
      setFieldValue("vlDeclarado", dadosOcorrencia.vlDeclarado);
      setFieldValue("vlDeclarado", dadosOcorrencia.vlApurado);
      setFieldValue("vlIcms", dadosOcorrencia.vlIcms);
      setFieldValue("vlMultaOcorrencia", dadosOcorrencia.vlMultaOcorrenciaAtual);
      setFieldValue("tipoDetalhamento", dadosOcorrencia.tipoDetalhamento);
    }
  }, [setFieldValue, dadosOcorrencia, sqAcaoFiscal, sqItemOcorrencia]);

  useEffect(() => {
    if (tipoDetalhamento === "Q") {
      setTituloVlDeclarado("Crédito indevido");
      setTituloVlApurado("Saldo credor/deduções");
      setDisabled(true);
    } else if (tipoDetalhamento === "Q2") {
      setTituloVlDeclarado("Saldo credor do período anterior na apuração");
      setTituloVlApurado("Saldo credor do período anterior transportado");
    } else if (tipoDetalhamento === "Q3") {
      setTituloVlDeclarado("Crédito apropriado");
    }
  }, [tipoDetalhamento]);

  return (
    <>
      <Row>
        <Form.Group className="mb-4" as={Col} sm={12} md={4}>
          <Form.Label>Referência:</Form.Label>
          <TextInputMaskFormik
            formik={formik}
            field="txReferencia"
            placeholder="mm/aaaa"
            mask="99/9999"
            evento={calculaData}
          />
        </Form.Group>
        <Form.Group className="mb-4" as={Col} sm={12} md={4}>
          <Form.Label>Data de Vencimento:</Form.Label>
          <DateTimeInputFormik formik={formik} field="dtVencimento" />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-4" as={Col} sm={12} md={4}>
          <Form.Label> {tituloVlDeclarado} (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlDeclarado"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
          />
        </Form.Group>
        {(tipoDetalhamento === "Q" || tipoDetalhamento === "Q2") && (
          <Form.Group className="mb-4" as={Col} sm={12} md={4}>
            <Form.Label>{tituloVlApurado} (R$): </Form.Label>
            <TextInputMoneyFormik
              formik={formik}
              field="vlApurado"
              type="number"
              prefix=" "
              onChange={handleMoneyChange}
              evento={() => calculaIcmsDet(tipoDetalhamento)}
            />
          </Form.Group>
        )}
      </Row>
      <Row>
        <Form.Group className="mb-4" as={Col} sm={12} md={4}>
          <Form.Label>ICMS a Recolher (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlIcms"
            type="number"
            prefix=" "
            onChange={handleMoneyChange}
            disable={disabled}
          />
        </Form.Group>
        {tipoDetalhamento !== "Q" && (
          <Form.Group className="mb-4" as={Col} sm={12} md={4}>
            <Form.Label>Multa (R$):</Form.Label>
            <TextInputMoneyFormik
              formik={formik}
              field="vlMultaOcorrencia"
              type="number"
              prefix=" "
              onChange={handleMoneyChange}
            />
          </Form.Group>
        )}
      </Row>
    </>
  );
};

export default DemonstrativoQ;
